import { render, staticRenderFns } from "./ErrorBadge.vue?vue&type=template&id=87360310"
import script from "./ErrorBadge.vue?vue&type=script&lang=js"
export * from "./ErrorBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports